module.exports = __webpack_public_path__ + "static/shop-7dcf466fcd3bdb7dadc8a115205364ef.png";